import { DEFAULT_REQUEST_LIMIT } from 'src/constants/requests'
import {
  CreateOrderRequestBody,
  Delivery,
  PostalAddress,
  Product,
  ProductCategory,
  UpdateCustomerRequestBody,
} from 'src/types/types'

import { FetchCoreAPI, WCRestAPI, WCStoreAPI } from './ApiService'
import { FetchCoreEndpoint, WcParams, WcRestEndpoint, WcStoreEndpoint } from './types'

export const getCart = async () => {
  const response = await WCStoreAPI.get(WcStoreEndpoint.Cart)
  return response.data || []
}

export const addToCart = async (productId, quantity) => {
  const config = {
    params: {
      id: productId,
      quantity: quantity,
    },
  }
  const response = await WCStoreAPI.post(`${WcStoreEndpoint.Cart}/add-item`, null, config)
  return response.data || {}
}

export const updateCartItem = async (key, quantity) => {
  const response = await WCStoreAPI.put(`${WcStoreEndpoint.Cart}/${key}`, {
    quantity: quantity,
  })
  return response.data || {}
}

export const removeCartItem = async (key) => {
  const response = await WCStoreAPI.post(`${WcStoreEndpoint.Cart}/remove-item?key=${key}`)
  return response.data || {}
}

export const clearCart = async () => {
  const response = await WCStoreAPI.delete(WcStoreEndpoint.Cart)
  return response.data || {}
}

export const getProductsRequest = async (queryParams: WcParams): Promise<Product[]> => {
  const response = await WCRestAPI.get(WcStoreEndpoint.Products, {
    params: {
      ...queryParams,
    },
  })

  return response.data || []
}

export const getPostalCodes = async (): Promise<PostalAddress[]> => {
  const response = await FetchCoreAPI.get(FetchCoreEndpoint.PostCodes)
  return response.data || []
}

export const getProductCategoriesRequest = async (page: number): Promise<ProductCategory[]> => {
  const response = await WCRestAPI.get(WcRestEndpoint.Categories, {
    params: {
      page,
      per_page: DEFAULT_REQUEST_LIMIT,
    },
  })
  return response.data ?? []
}

export const getProductTagsRequest = async (queryParams: WcParams): Promise<ProductCategory[]> => {
  const response = await WCRestAPI.get(WcRestEndpoint.Tags, {
    params: queryParams,
  })
  return response.data ?? []
}

export const createOrderRequest = async (body: CreateOrderRequestBody): Promise<unknown> => {
  const response = await WCRestAPI.post(WcRestEndpoint.Orders, body)
  return response.data || {}
}

export const updateCustomerRequest = async (body: UpdateCustomerRequestBody): Promise<unknown> => {
  const response = await WCStoreAPI.post(WcStoreEndpoint.UpdateCustomer, body)
  return response.data || {}
}

export const getOrderDetailsRequest = async (orderId: number): Promise<unknown> => {
  const response = await WCStoreAPI.get(`${WcStoreEndpoint.OrderDetails}/${orderId}`)
  return response.data || {}
}

export const createCustomerRequest = async (data: any): Promise<unknown> => {
  const response = await WCStoreAPI.post(WcStoreEndpoint.CreateCustomer, data)
  return response.data || {}
}

export const getCustomerDetailsRequest = async (customerId: number): Promise<unknown> => {
  const response = await WCStoreAPI.get(`${WcStoreEndpoint.CustomerDetails}/${customerId}`)
  return response.data || {}
}

export const getDeliveryDetails = async (deliveryId: string): Promise<Delivery> => {
  const response = await FetchCoreAPI.get(`${FetchCoreEndpoint.Delivery}/${deliveryId}`)
  return response.data || {}
}
